// --------------------------------------------------------------
// Created On: 2024-09-25
// Author: Zachary Thomas
//
// Last Modified: 2024-09-25
// Modified By: Zachary Thomas
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Get a string for a data object that describes the current hour.
export default function formatDateObjectHourlyLocal(dateObject: Date): string {
  return dateObject.toLocaleDateString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour12: true,
    hour: "numeric",
  });
}
